import * as colors from '@atlaskit/theme/colors';

import { PipelineFillState } from '../constants';

export function getFillStatusColor(fillState: PipelineFillState): string {
  switch (fillState) {
    case PipelineFillState.Success:
      return colors.G300;
    case PipelineFillState.Skipped:
      return colors.Y300;
    case PipelineFillState.Failure:
      return colors.R300;
    case PipelineFillState.Other:
    default:
      return '';
  }
}
